<template>
  <div class="header">
    <div class="headerImg">
      <img
        src="../../assets/images/icon_changeMenu.png"
        :class="[{'nav-menu-active': this.$store.state.isNavMenuOpen},'nav-menu']"
        @click="changeNavMenuStatus"
      >
      <img src="../../assets/images/system_title.svg" @click="goHome" alt="" style="height: 20px;margin-left: 12px;margin-top: 5px;">
    </div>
    <div class="user-info">
      <div
        class="userinfo-inner"
        style="position: relative"
      >
        <div
          :class="loginOutShow ? 'loginOutShow' : 'noLoginOutShow'"
          class="userName"
          @click="loginOutShow = !loginOutShow"
        >
          {{ nickname }}
        </div>
        <img
          v-if="!loginOutShow"
          src="../../assets/images/userDown.png"
          alt="退出"
          style="width: 18px; height: 18px; margin-left: 2px"
          @click="loginOutShow = true"
        />
        <img
          v-if="loginOutShow"
          src="../../assets/images/loginOutUp.png"
          alt="退出"
          style="width: 18px; height: 18px; margin-left: 2px"
          @click="loginOutShow = false"
        />
        <div @click.stop="loginOut" class="loginOut" v-if="loginOutShow">
          <p>退出登录</p>
          <span class="el-icon-arrow-right"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import passport from'@/assets/js/passport.js'
export default {
  name: 'navTitle',
  data() {
    return {
      loginOutShow: false
    };
  },
  methods: {
    goHome() {
      let routeData = this.$router.resolve({
        path: '/',
      });
      window.open(routeData.href, '_blank');
    },
    loginOut() {
      this.$confirm('确认要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      }).then(() => {
          this.$request(this.$api.logout).then((res) => {
            try {
              if (res.data.data) {
                // 退出成功时，清空store中用户信息
                this.$store.commit('setUserInfo', {});
                if (window.event && window.event.preventDefault)
                  window.event.preventDefault();
                  console.log(passport.loginout(),encodeURIComponent(window.location.origin + '/#/homeView/workFlowConfig'))
                  window.location.href = passport.loginout() + encodeURIComponent(window.location.origin + '/#/homeView/workFlowConfig')
              }
            } catch (e) {
              this.$utils.throwError(this, e);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出',
          });
          this.loginOutShow = false;
        });
    },
    changeNavMenuStatus(){
      this.$store.commit('setIsNavMenuOpen',!this.$store.state.isNavMenuOpen)
    }
  },
  computed: {
    nickname: function () {
      return this.$store.state.userInfo.nickname || this.$store.state.userInfo.realName;
    }
  }
};
</script>

<style  scoped>
.loginOut {
  position: absolute;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-top: 2px solid #5587f0;
  right: 0;
  top: 54px;
  padding: 0 18px;
  z-index: 2;
  width: 132px;
  height: 32px;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.loginOutShow {
  color: #5587f0;
}
.loginOut:hover,
.el-icon-arrow-right:hover {
  background-color: #eef3fd;
  color: #5587f0;
}

.header {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(205, 205, 205, 0.23);
  position: fixed;
  z-index: 99;
  display: flex;
}
.headerImg {
  cursor: pointer;
  display: flex;
  flex-flow: row;
  align-items: center;
  padding-left: 10px;
}
.headerImg img {
    display: block;
    height: 20px;
}
.user-info {
  display: flex;
  flex-wrap: nowrap;
  font-size: 14px;
  padding-right: 40px;
  justify-content: flex-end;
  flex: auto;
}

.userinfo-inner {
  margin-left: 20px;
  font-size: 14px;
  color: #323232;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  cursor: pointer;
}
.userinfo-inner img {
  width: 18px;
  height: 16px;
  margin-right: 8px;
}
.userName {
  min-width: 60px;
  height: 100%;
  text-align: right;
}

.nav-menu{
  width: 18px;
  height: 18px;
  transform: translateY(3px) rotateY(0deg);
}

.nav-menu-active{
  transform: translateY(3px) rotateY(180deg);
}

.el-menu--popup {
  min-width: 150px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/navTitle.vue